import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
export const SipColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  return [
    // {
    //   title: "No",
    //   dataIndex: "SipNo",
    //   key: "SipNo",
    //   sorter: (a, b) => a?.SipNo - b?.SipNo,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="SipNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "SipNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "SIP ID",
      dataIndex: "SipId",
      key: "SipId",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="SipId"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "SipId",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Password",
      dataIndex: "Password",
      key: "Password",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Password"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Password",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Mac"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Mac",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-1 rounded-[4px] mr-1 ">
                  <Link
                    to={`/sip/edit/${record?.SipNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.SipNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-1 py-1 rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
